<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        การจัดการ กลุ่ม Device
      </span>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="uiCtrl && !uiCtrl.isEnable('btn:::hardware_group:create')"
        color="primary"
        @click="handleAddHardwaresGroupForm"
      >
        <v-icon small left>mdi-plus</v-icon>เพิ่มกลุ่ม Device
      </v-btn>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="hardwaresGroup"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <HardwareGroupForm
      :formShow="hardwareGroupFormShow"
      :formAction="hardwareGroupFormAction"
      :hardwareGroup="hardwareGroup"
      :hardwareGroupInit="hardwareGroupInit"
      @isHardwareGroupDataChange="handleHardwareGroupFormDataChange"
      @formActionCompleted="handleHardwareGroupFormActionCompleted"
      @onReset="handleHardwareGroupFormReset"
      @onClickAddHardware="hardwareGroupAddShow = true"
      @addHardwareGroupSuccess="handleAddHardwareGroupSuccess"
    />
    <HardwareGroupAdd
      :formShow="hardwareGroupAddShow"
      :hardwareGroup="hardwareGroup"
      :hardwareGroupInit="hardwareGroupInit"
      @isHardwareGroupAddDataChange="handleHardwareGroupAddDataChange"
      @onClickBlack="hardwareGroupAddShow = false"
      @addHardwareGroupMemberSuccess="handleAddHardwareGroupMemberSuccess"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="
        (hardwareGroupFormShow && hardwareGroupFormAction === 'add') ||
        hardwareGroupAddShow
      "
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import HardwareGroupAdd from '@/views/hardwares-group/HardwareGroupAdd.vue'
import HardwareGroupForm from '@/views/hardwares-group/HardwareGroupForm.vue'

export default {
  components: {
    HardwareGroupForm,
    HardwareGroupAdd,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['hardware_group_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      hardwareGroupFormShow: false,
      hardwareGroupAddShow: false,
      hardwareGroupFormAction: '',
      hardwareGroup: {},
      hardwareGroupInit: {},
      isHardwareGroupDataChange: false,
      isHardwareGroupAddDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    headers() {
      return [
        {
          text: 'รหัสกลุ่ม Device',
          align: 'start',
          value: 'hardware_group_code',
        },
        { text: 'คำอธิบาย (ไทย)', align: 'start', value: 'title_th' },
        {
          text: 'จำนวน Device',
          align: 'start',
          value: 'total_hardware',
        },
      ]
    },
    hardwaresGroup() {
      return this.$store.state.hardwaresGroup.hardwaresGroup
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การจัดการ กลุ่ม Device',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    this.loading = true

    Promise.all([
      this.fetchHardwaresGroup({ company_uuid }),
      this.fetchHardwareModels(company_uuid),
    ])
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchHardwaresGroup: 'hardwaresGroup/fetchHardwaresGroup',
      fetchHardwareModels: 'hardware/fetchHardwareModels',
    }),
    handleAddHardwareGroupMemberSuccess(hardwareGroup) {
      this.hardwareGroupAddShow = false
      this.hardwareGroup = { ...hardwareGroup }
      this.hardwareGroupInit = { ...hardwareGroup }
    },
    handleAddHardwareGroupSuccess(hardwareGroup) {
      this.hardwareGroup = { ...hardwareGroup }
      this.hardwareGroupInit = { ...hardwareGroup }
    },
    classRowSelected(row) {
      if (this.hardwareGroup.hardware_group_uuid === row.hardware_group_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::hardware_group:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.hardwareGroup.hardware_group_uuid === row.hardware_group_uuid) {
        this.hardwareGroupFormShow = false
        this.hardwareGroupFormAction = ''
        this.hardwareGroup = {}
        this.hardwareGroupInit = {}
      } else {
        this.hardwareGroupFormShow = true
        this.hardwareGroupFormAction = 'edit'
        this.hardwareGroup = { ...row }
        this.hardwareGroupInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isHardwareGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddHardwaresGroupForm() {
      this.hardwareGroupFormShow = true
      this.hardwareGroupFormAction = 'add'
      this.hardwareGroup = {}
      this.hardwareGroupInit = {}
    },
    handleHardwareGroupFormDataChange(value) {
      this.isHardwareGroupDataChange = value
    },
    handleHardwareGroupAddDataChange(value) {
      this.isHardwareGroupAddDataChange = value
    },
    handleHardwareGroupFormReset(formAction) {
      if (formAction === 'edit') {
        this.hardwareGroup = { ...this.hardwareGroupInit }
      }
    },
    handleHardwareGroupFormActionCompleted(formAction) {
      this.hardwareGroup = {}
      this.hardwareGroupInit = {}
      this.hardwareGroupFormShow = false
      this.hardwareGroupFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.hardwareGroupFormShow = false
      this.hardwareGroupAddShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isHardwareGroupDataChange || this.isHardwareGroupAddDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
